import Fragment from 'vue-fragment';
import Vue from 'vue';

Vue.use(Fragment.Plugin);

import { Plugin } from 'vue-fragment';
Vue.use(Plugin);